import HeaderRow from "@edaz/edazkit/HeaderRow";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Tabs from "../../common/tabs";
import React from "react";
import PaymentsViewModel from "viewModels/finance/payments/paymentsViewModel";

const PaymentsView: ViewComponent<PaymentsViewModel> = observer(({ vm }) => (
  <div className="finance-payments">
    {vm.isDetailChildActivated ? (
      <View vm={vm.detailChildActivated} />
    ) : (
      <>
        <HeaderRow title={vm.name} level={3} className="mb-4 text-center"></HeaderRow>
        <Tabs
          itemsCount={vm.itemsCount}
          totalCountBankTransfers={vm.totalCountBankTransfers}
          totalCountCardGateways={vm.totalCountCardGateways}
          vm={vm}
        />
      </>
    )}
  </div>
));

registerView(PaymentsView, PaymentsViewModel);
